import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useMyGlobal } from "../../component/GlobalData";
import { Button } from "semantic-ui-react";

export const LivinSukha = () => {
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const email = queryParams.get('email')
    const fName = queryParams.get('fname')
    const lName = queryParams.get('lname')
    const { token, windowWidth } = useMyGlobal()
    const [loader, setLoader] = useState(false)

    const emailChecking = async (eAddr) => {
        const param = new FormData()
        param.append('email', eAddr)
        await axios({
            method:'POST',
            url: `${process.env.REACT_APP_SRV_API_URL}controler/livinSukha.php?action=emailCheck`,
            headers:{
                'content-type':'application/x-www-form-urlencoded',
                'Authorization': token
            },
            data:param
        }).then (res => {
            if (res.data.state === 200){
                //console.log(res.data)
            }
        })
    }

    useEffect(() => {
        emailChecking(email)
    },[])
    
    return (
        <>
            <Container className='mt-5 mb-5 pt-5' fluid='sm' style={{ minHeight: '100vh', height: '100%' }}>
                <Row className="mt-3 d-flex justify-content-center" >
                    <Col xl={10} lg={12} md={12}>
                        <div className="h3 text-uppercase">Disclaimer</div>
                        <div className="mb-4">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                        </div>
                        <Button content="OK, I understand" icon="arrow alternate circle right" labelPosition="right" color="orange"/>
                    </Col>
                </Row>
            </Container>
        </>
    )
}
